export default __webpack_public_path__ + "static/media/007-apartment.8e5d0462.svg";